import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
  FormField,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';
import React from 'react';
import { FieldPathByValue, FieldValues } from 'react-hook-form';

import { FieldProps } from './shared';

export function TextareaField<
  T extends FieldValues,
  P extends FieldPathByValue<T, string>,
>({
  control,
  name,
  rules,
  label,
  description,
  className,
  resizable,
  ...props
}: FieldProps<T, P> &
  React.ComponentPropsWithoutRef<typeof Textarea> & {
    resizable?: boolean;
  }) {
  return (
    <FormField
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <FormItem className="grow">
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Textarea
              className={cn(className, { 'resize-none': !resizable })}
              {...props}
              {...field}
            />
          </FormControl>
          <FormDescription>{description?.(field.value)}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
